import React, { ReactElement } from 'react';
import { compose } from 'redux';
import { Gallery } from 'b2b-components/theme/components/Gallery';
import { withEmptyDataHandler } from 'b2b-apps/shop/common/hoc/withEmptyDataHandler';
import { withFailHandler } from 'b2b-apps/shop/common/hoc/withFailHandler';
import { withLoader } from 'b2b-apps/shop/common/hoc/withLoader';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { ProductGallerySkeleton } from './ProductGallerySkeleton';
import { Props } from './';

const ProductGallery = (props: Props): ReactElement => {
  const t = useTranslate();

  const text = {
    menuMobileImageLink: t('Images'),
    menuMobileVideoLink: t('Videos'),
    modalAriaLabel: t('Gallery'),
    modalCloseLabel: t('Close Gallery'),
    spinHint: t('Drag to spin. Click to zoom.'),
    spinHintMobile: t('Swipe to spin.'),
    zoomHint: t('Click to zoom.'),
    zoomHintMobile: t('Double tap to zoom.'),
  };

  return (
    <div className="ProductPhotos">
      <Gallery
        deviceType={props.deviceType}
        images={props.galleryPhotos}
        image360={props.gallery360}
        key={props.sku}
        videos={props.galleryVideos}
        title={props.productName}
        imageUrl={props.cdnUrl}
        manufacturerLink={props.manufacturerLink}
        onManufacturerLogoClick={props.onManufacturerLogoClick}
        manufacturerLogoUrl={props.manufacturerLogoUrl}
        text={text}
      />
    </div>
  );
};

const ComposedProductGallery = compose(
  withLoader(
    (props: Props) => [props.gallery],
    false,
    ProductGallerySkeleton,
  ),
  withFailHandler((props) => [props.gallery]),
  withEmptyDataHandler((props) => [props.gallery]),
)(ProductGallery);

export { ComposedProductGallery as ProductGallery };
